import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';

import { ModalService } from '@rpgc-ai/services/modal/modal.service';

/**
 * Guard для маршрута modal:template.
 * Если templateRef не задан (например, после перезагрузки), не показываем модалку
 * и перенаправляем на тот же URL без outlet modal.
 */
export const templateModalGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const modalService = inject(ModalService);
  const router = inject(Router);

  if (modalService.templateRef() !== null) {
    return true;
  }

  // Убираем из URL часть с модальным окном (modal:template)
  const baseUrl = state.url.replace(/\(modal:[^)]+\)/, '').replace(/^\/+/, '/') || '/';
  return router.parseUrl(baseUrl);
};
